/* Small filter-bar helpers shared between FTEReport.js and FTEReportFilterBar.js — same
   generic pattern as aop-budget/aopBudgetFilterHelpers.js. */
import { FILTERS_CONFIG, isFilterActive } from "../GlobalFilterPanel";

export function filtersForKeys(keys) {
  if (!keys?.length) return FILTERS_CONFIG;
  const byKey = Object.fromEntries(FILTERS_CONFIG.map((f) => [f.key, f]));
  return keys.map((k) => byKey[k]).filter(Boolean);
}

/** True when every visible filter is at its default (no active filter chips) — used to
 *  disable "Clear All" when there's nothing to clear. This report has no year filter
 *  (its time axis is the Date Range picker instead), so unlike AOP Budget's
 *  isOnlyDefaultYear, this simply checks every visible key is inactive. */
export function isDefaultFilters(filterValues, vKeys) {
  const keys = vKeys || FILTERS_CONFIG.map((f) => f.key);
  return !keys.some((k) => {
    const f = FILTERS_CONFIG.find((fc) => fc.key === k);
    return f && isFilterActive(f, filterValues[k]);
  });
}
